<template>
  <div>
    <div class="loading" v-if="loading">
      <div class="spinner"></div>
    </div>
    <b-card v-else>
      <div slot="header" v-if="!add && lock">
        File Detail
      </div>
      <div slot="header" v-if="!add && !lock">
        Modify File
      </div>
      <div slot="header" v-if="add && !lock">
        Create File
      </div>

      <b-row>
        <b-col md="6">
          <b-form-group class="text-primary" label="Clear" label-for="ph_is_clear">
            <c-switch color="info" label size="lg" id="ph_is_clear" v-model="model.is_clear" :disabled="lock" />
          </b-form-group>
        </b-col>
        <!-- <b-col md="6" v-if="!lock && !add">
          <b-form-group class="text-primary" label="Distribute" label-for="ph_is_use">
            <c-switch color="info" label size="lg" id="ph_is_use" v-model="model.distribute" :disabled="lock" />
          </b-form-group>
        </b-col> -->
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group class="text-primary">
            <label for="ph_type">Extension</label>
            <!-- <v-select v-if="!lock" label="type" v-model="model.types" :options="rule_type" @input="changeDistribute"></v-select> -->
            <b-input type="text" :disabled="lock" :value="model.extension" plaintext></b-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group class="text-primary">
            <label for="ph_level">Extension Category</label>
            <!-- <v-select v-if="!lock" label="level" v-model="model.extension_category" :options="rule_level" @input="changeDistribute"></v-select> -->
            <b-input type="text" :value="model.extension_category" :plaintext="lock" aria-readonly="true"></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group class="text-primary">
            <label for="ph_issue_date">Registed At</label>
            <b-form>
            <!-- <date-picker v-if="!lock" id="ph_issue_date" v-model="model.created_at" type="datetime" class="mb-2"></date-picker>
            <b-input v-if="lock" type="datetime" v-bind:value="model.created_at | datetime" plaintext></b-input> -->

            <b-input type="datetime" v-bind:value="model.created_at | datetime" plaintext></b-input>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group class="text-primary">
            <label for="ph_from">From</label>
            <b-input type="text" id="ph_from" v-model="model.origin" :plaintext="lock"></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-form-group class="text-primary">
            <label for="ph_file_name">filename</label>
            <b-input type="text" id="ph_file_name" v-if="add" v-model="model.file_name" placeholder="Code"></b-input>
            <b-input type="text" id="ph_file_name" v-if="!add" v-model="model.file_name" plaintext></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-form-group class="text-primary">
            <label for="ph_file_ssdeep">File SSDEEP</label>
            <b-input type="text" id="ph_file_ssdeep" v-model="model.file_ssdeep" plaintext></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="12">
          <b-form-group class="text-primary">
            <label for="ph_file_content">File Content</label>
            <codemirror @input="x => model.file_content = x" v-model="model.file_content" :options="options_rule" :style="{ height: '800px' }" :readonly="lock"/>
          </b-form-group>
        </b-col>
      </b-row>

      <hr>

      <b-button class= "mr-1" size="sm" variant="light" @click="back"> Back </b-button>
      <template v-if="lock">
        <div v-if="profile.permission == 'Master'" class="float-right">
          <b-button class= "mr-1" size="sm" variant="primary" @click="edit"> Modify </b-button>
          <b-button size="sm" variant="danger" @click="confirm = true"> Delete </b-button>
        </div>
      </template>
      <template v-else>
        <div class="float-right">
          <b-button class="mr-1" size="sm" variant="danger" @click="cancel"> Cancel </b-button>
          <b-button size="sm" variant="primary" @click="save"> Save </b-button>
        </div>
      </template>
    </b-card>
    <b-modal title="Confirm - Delete user account" class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      Deleted data cannot be reversed. Are you sure?
    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { api, auth } from '@/f1/service';
// import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
// import * as forge from 'node-forge'
// import reg from '@/f1/reg'
import 'vue-select/dist/vue-select.css';

import { codemirror } from 'vue-codemirror'

// import dedent from 'dedent'
// require styles
import 'codemirror/lib/codemirror.css'
// theme css
import 'codemirror/theme/dracula.css'; // Dracula 테마
import 'codemirror/theme/monokai.css'; // Monokai 테마
import 'codemirror/theme/material.css'; // Material 테마

// language
import 'codemirror/mode/vue/vue.js'
import 'codemirror/mode/php/php'; // PHP 코드 모드 가져오기
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css';
import 'codemirror/mode/python/python';



import 'codemirror/addon/scroll/annotatescrollbar.js'
import 'codemirror/addon/search/matchesonscrollbar.js'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/match-highlighter.js'
// keyMap
import 'codemirror/mode/clike/clike.js'
import 'codemirror/addon/edit/matchbrackets.js'
import 'codemirror/addon/comment/comment.js'
import 'codemirror/addon/dialog/dialog.js'
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/search.js'
import 'codemirror/keymap/sublime.js'
// foldGutter
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/brace-fold.js'
import 'codemirror/addon/fold/comment-fold.js'
import 'codemirror/addon/fold/foldcode.js'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/indent-fold.js'
import 'codemirror/addon/fold/markdown-fold.js'
import 'codemirror/addon/fold/xml-fold.js'

const default_model = () => ({ is_use: true, type: 'URL', level: 'Danger', is_direct: false, distribute : false, issue_date : new Date(), origin : 'F1', claim_date : new Date() });
// var beforeModel = {};

export default {
  components: { cSwitch, vSelect, DatePicker, codemirror },
  data : () => ({
    loading: false,
    options_rule: {
      tabSize: 4,
      highlightDifferences: true,
      // mode: 'text',
      theme: 'material',
      lineNumbers: true,
      line: true,
      mode: 'php',
      lineWrapping: true,
    },
    confirm: false,
    add: false,
    lock: true,
    model : default_model(),
    profile: auth.profile,
    analsisData : ""
  }),
  computed: {
    last_info() { return `${this.$options.filters.sdate(this.model.last_visit)} @ ${this.model.last_addr}`; }
  },
  methods: {
    cancel() { this.$router.replace({ name: 'cti_webshell', params: { id: this.model.id }}); },
    edit() { this.model; this.$router.replace({ name: 'cti_webshell', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try {
        await api.dms.upload.delete(this.model.id);
        this.$emit('refresh'); this.$toastr.s('Rule deleted.'); this.list();
      } catch(e) { this.$toastr.e(e.data || e); this.list(); }
    },
    back() { this.$router.go(-1); },
    list() { this.$router.push({ name: 'cti_webshell'}); },
    changeDistribute() { this.model.distribute = true; },
    async save() {
      if(!(this.model.file_hash || '').trim()) { return this.$toastr.e('File Hash required.'); }
      if(!(this.model.file_content || '').trim()) { return this.$toastr.e('File Content required.'); }
      if(!(this.model.file_ssdeep || '').trim()) { return this.$toastr.e('File ssdeep required.'); }

     try {
        if(this.model.id) {

          await api.dms.upload.update(Object.assign({}, this.model, { file_content : btoa(this.model.file_content) }));
        } else {

          this.model.id = +(await api.dms.upload.add(this.model));
        }
        this.$toastr.s('Done.'); this.$emit('refresh'); this.cancel();

      } catch(e) { this.$toastr.e(e.data || e); this.cancel(); }

      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      this.loading = true;
      try {
        console.log('[vue] rule.detail', 'load item', id);

        if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
        else { this.add = false; }

        this.lock = (tag !== 'edit');

        this.model = Object.assign({}, this.model, await api.dms.upload.get(id));
        this.model.file_content = atob(this.model.file_content)
      }
      catch(e) { console.log(e); this.$toastr.e(e.data || e); this.list(); }
      finally { this.loading = false; }
    },
  },
  // watch: { '$route' (to, from) { this.get(to.params); console.log(from) } },
  created() { },
  destroyed() { },
  mounted() {
    this.get(this.$route.params);
  }
}
</script>

<style>

body .CodeMirror-wrap {
  height: 800px !important;
}

</style>
